import g from '#core/global';
import load from '#core/load';
import util from '#core/util';


const timeline_$ = '.timeline';
const track_$ = '[data-timeline-track]';
const previous_$ = '[data-timeline-previous]';
const next_$ = '[data-timeline-next]';
const jump_$ = '[data-timeline-jump]';
const year_marker_$ = year => `[data-timeline-year="${year}"]`;
const disabled_attr = 'disabled';

let has_timeline = false;


const module = {

	/**
	 * Init module
	 */
	init() {
		if (load.ran('timeline')) return false;

		load.content(() => {
			has_timeline = assign_elements();
		});
		load.all(() => {
			has_timeline = assign_elements();
		});
	},

};

export default module;
module.init();


/**
 * Assign elements and event listeners
 * @return {boolean}
 */
function assign_elements() {
	if (has_timeline) return true;

	const $timelines = document.querySelectorAll(timeline_$);
	if (!$timelines.length) return false;

	$timelines.forEach($timeline => {
		const $track = $timeline.querySelector(track_$);
		const $previous = $timeline.querySelector(previous_$);
		const $next = $timeline.querySelector(next_$);
		if (!$track || !$previous || !$next) return false;

		$previous.addEventListener(g.click_e, () => {
			advance($track, -1);
		});
		$next.addEventListener(g.click_e, () => {
			advance($track, 1);
		});

		$track.addEventListener(g.scroll_e, util.throttle(() => {
			update_arrow_states($track, $previous, $next);
		}, 100));

		window.addEventListener(g.resize_e, util.throttle(() => {
			update_arrow_states($track, $previous, $next);
		}, 150));

		update_arrow_states($track, $previous, $next);

		const $jump = $timeline.querySelector(jump_$);
		if ($jump) {
			$jump.addEventListener(g.change_e, () => {
				jump_to_year($track, $jump.value);
			});
		}
	});

	return true;
}


/**
 * Scroll the track to the first li (year-marker or item) that is not completely visible.
 * For next: aligns the first item poking out on the right.
 * For prev: aligns the rightmost item cut off on the left.
 * @param {element} $track
 * @param {number} direction - 1 = next, -1 = prev
 */
function advance($track, direction) {
	const track_rect = $track.getBoundingClientRect();
	const items = Array.from($track.querySelectorAll('li'));

	let target = null;

	if (direction === 1) {
		target = items.find(item => item.getBoundingClientRect().right > track_rect.right + 1);
	} else {
		const hidden = items.filter(item => item.getBoundingClientRect().left < track_rect.left - 1);
		target = hidden[hidden.length - 1] ?? null;
	}

	if (!target) return;

	// Disable scroll-snap while scrolling so it doesn't override our target position,
	// then restore it once the scroll animation ends.
	const scroll_padding = parseFloat(getComputedStyle($track).scrollPaddingInlineStart) || 0;
	const scroll_left = target.getBoundingClientRect().left - track_rect.left + $track.scrollLeft - scroll_padding;

	$track.style.scrollSnapType = 'none';
	$track.scrollTo({ left: scroll_left, behavior: 'smooth' });

	const restore_snap = () => $track.style.removeProperty('scroll-snap-type');
	$track.addEventListener('scrollend', restore_snap, { once: true });
	setTimeout(restore_snap, 1000);
}


/**
 * Scroll the track to the item that has the given year marker.
 * @param {element} $track
 * @param {string} year
 */
function jump_to_year($track, year) {
	const $marker = $track.querySelector(year_marker_$(year));
	if (!$marker) return;

	const $item = $marker.closest('li');
	if (!$item) return;

	$track.scrollTo({
		left: $item.offsetLeft - $track.offsetLeft,
		behavior: 'smooth',
	});
}


/**
 * Toggle disabled state on prev/next based on scroll position.
 * @param {element} $track
 * @param {element} $prev
 * @param {element} $next
 */
function update_arrow_states($track, $prev, $next) {
	const at_start = $track.scrollLeft <= 1;
	const at_end = $track.scrollLeft + $track.clientWidth >= $track.scrollWidth - 1;

	if (at_start) {
		$prev.setAttribute(disabled_attr, '');
	} else {
		$prev.removeAttribute(disabled_attr);
	}

	if (at_end) {
		$next.setAttribute(disabled_attr, '');
	} else {
		$next.removeAttribute(disabled_attr);
	}
}
